import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../api/CallUserApi';
import { BaseUserInfo } from '../../interface/BaseUserInfo';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import NoReportTooltip from '../NoReportTooltip';
import UnsavedReportAlertModal from './UnsavedReportAlertModal';
import { ACCOUNT } from '../../enum/AccountEnum';
import CommonHeader, { HeaderMenuItem } from './CommonHeader';
import useHeaderNavigationGuard from './useHeaderNavigationGuard';

export interface HeaderProps {
  user: BaseUserInfo;
  isBtnDisabled: boolean;
  isDisableHalfWrittenBtn: boolean;
}

const Header: React.FC<HeaderProps> = ({ user, isBtnDisabled, isDisableHalfWrittenBtn }) => {
  const globalDisplayName = useSelector((state: RootState) => state.displayName.displayName);
  const globalInstitutionName = useSelector((state: RootState) => state.institution.name);
  const target = useRef(null);
  const { wrapWithNavigationGuard, isDisplayModal, handleCloseModal, handleClickOk } = useHeaderNavigationGuard();
  const navigate = useNavigate();

  const handleClickReportsPageButton = () => navigate('reports');
  const moveCreateNewReportPage = () => navigate('regist/lesson');
  const moveHalfWrittenReportPage = () => {
    localStorage.setItem(user._id + '_editType', 'halfWritten');
    navigate('regist/lesson');
  };
  const handleClickInfoPageButton = () => navigate('info');
  const handleClickLogoutButton = async () => {
    await api.Logout();
    navigate('login');
  };

  const menuItems: HeaderMenuItem[] = [
    {
      key: 'new-report',
      label: '新規登録',
      onClick: moveCreateNewReportPage,
      disabled: isBtnDisabled,
      targetRef: target,
    },
    {
      key: 'half-written',
      label: '書きかけ編集',
      onClick: moveHalfWrittenReportPage,
      disabled: isBtnDisabled || isDisableHalfWrittenBtn,
    },
    {
      key: 'reports',
      label: '利用報告一覧',
      onClick: () => wrapWithNavigationGuard(handleClickReportsPageButton),
    },
    {
      key: 'documents',
      label: '関連資料',
      href: 'https://sartras.or.jp/hokoku/hokoku-documents/',
      newTab: true,
      showExternalIcon: true,
    },
  ];

  return (
    <>
      <CommonHeader
        displayLines={[globalInstitutionName, `${ACCOUNT.USERS}： ${globalDisplayName} 様`]}
        menuItems={menuItems}
        onClickLogo={() => wrapWithNavigationGuard(handleClickReportsPageButton)}
        onClickInfo={() => wrapWithNavigationGuard(handleClickInfoPageButton)}
        onClickLogout={() => wrapWithNavigationGuard(handleClickLogoutButton)}
        showOpinionAction
        menuSupplement={<NoReportTooltip target={target} />}
      />
      <UnsavedReportAlertModal isDisplayModal={isDisplayModal} handleCloseModal={handleCloseModal} handleClickOk={handleClickOk} />
    </>
  );
};

export default Header;
